import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card-grupo',
  templateUrl: './card-grupo.component.html',
  styleUrls: ['./card-grupo.component.css']
})
export class CardGrupoComponent implements OnInit {
  @Input() data: any[];
  @Output() editClick = new EventEmitter<any>();
  @Output() deleteClick = new EventEmitter<any>();
  @Output() enableClick = new EventEmitter<any>();
  @Output() selectedClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}
  setColor(nombre: any) {
    let color = '';
    switch (nombre) {
      case 'BASICO':
        color = 'bg-success';
        break;
      case 'INTERMEDIO':
        color = 'bg-warning';
        break;
      case 'AVANZADO':
        color = 'bg-danger';
        break;
    }
    return color;
  }
}
